import { ShareClass, ShareOption, ImportShareholder } from './shared';

// For cap table display
export class ShareOptionDisplay extends ShareOption {
  isExpanded = true; // Boolean didnt work for *ngIf checks...
  visible: boolean = null;
  isSimulationOption: boolean = null;
}

// For cap table display
export class ShareClassDisplay extends ShareClass {
  // isExpanded: boolean = true; // Boolean didnt work for *ngIf checks...
  // visible: boolean = null;
  isSimulationOption: boolean = null;
}

// Might not need this
export class Simulation {
  // valuationTime: string = null; // Pre or post value
  desiredResult: number = null; // What the result is
  selectedDesired: string = null; // What result the user wants to see
  // dilutedOption: string = null;
  diluted: boolean = null;
  investorCapital: number = null;
  investorCapitalPostMoney: number = null;
  companyCapital: number = null;
  investorOwnership: number = null; // In percentage
  type: string = null;
  name: string = null;
  amount: number = null;
}

export const CAPTABLEROWS: string[] = [
  'Share class',
  'Option',
  // 'Convertible debt'
];

export class TaxOfficeCompanyData {
  orgno: string;
  companyName: string;
  totshares: string;
  shareholders: ImportShareholder[];
}

// export class EntityOrig extends ShareholderRecord {
//   mobile: string = null;
//   tlf: string = null;
//   jobtlf: string = null;
//   address_details: string = null;
//   residence_address: string = null;
//   zip: string = null;
//   city: string = null;
//   country: string = null;
//   banknr: string = null;
//   residence_zip: string = null;
//   residence_city: string = null;

//   // For the demo
//   // shareclass: ShareClass = SHARECLASSES[0];

//   // roles: {[id: string]: boolean} = {};
// }

// // export function displaySSN(p: EntityOrig): string {
// //     if (p) {
// //         if (p.isCompany) {
// //             if (p.orgnr) {
// //                 return p.orgnr;
// //             }
// //         } else {
// //             let ssn = "";
// //             if (p.ssn) {
// //                 ssn = p.ssn;
// //             }
// //             return ssn;
// //         }
// //     } else {
// //         return "";
// //     }
// // }
